import { BaseCommandProvider } from "common/app/command-palette/providers/base-provider";
import { Command } from "../types";

export class HistoryProvider extends BaseCommandProvider {
  getCommands(): Command[] {
    return [
      {
        id: "history:back",
        label: _("Go Back"),
        icon: "fa-arrow-left",
        onClick: () => window.history.back(),
      },
      {
        id: "history:forward",
        label: _("Go Forward"),
        icon: "fa-arrow-right",
        onClick: () => window.history.forward(),
      },
    ];
  }
}
